/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, April 2020
 */

import React, { useEffect } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { convertCssUnit } from '@staffino/primitive-controls';
import Header from './header';
import { EmoticonsControl } from './controls';
import { ScrollAnchor, useScrollEffect } from './scroll';

export default function EmoticonsQuestionBlock({ question, block, onSelect }) {
  const { t } = useTranslation();
  const context = useFormContext();

  const EmoticonsControlComponent = context ? Controller : EmoticonsControl;

  const score = context?.watch(`${block.id}.score`);
  const scoreError = context?.errors[block.id]?.score;
  const required = block.required ?? question.required;
  const titleSize = question.extraParams?.titleSize ?? block.titleSize;
  const scoreValidation = { required };
  const { scrollToError } = useScrollEffect(`${block.id}.score`, score);

  useEffect(() => {
    if (score > 0) {
      onSelect(score);
    }
  }, [score]);

  return (
    <>
      <ScrollAnchor id={`${block.id}.score`} />
      <Header
        question={question}
        size={titleSize}
        required={required}
        answerErrorMessage={scoreError && t('Please answer this question.')}
      />
      <EmoticonsControlComponent
        as={EmoticonsControl}
        name={`${block.id}.score`}
        control={context?.control}
        rules={scoreValidation}
        upperBoundScore={question.upperBoundScore ?? undefined}
        steps={question.steps}
        width={1}
        maxWidth={convertCssUnit('30rem')}
        onFocus={() => scrollToError(`${block.id}.score`)}
        marginTop={convertCssUnit(titleSize === 'small' ? '0.75rem' : '2rem')}
        marginLeft="auto"
        marginRight="auto"
        marginBottom={0}
      />
    </>
  );
}
